export const RUN_FAKESHIELD_DTE_REQUEST = 'RUN_FAKESHIELD_DTE_REQUEST';
export const RUN_FAKESHIELD_DTE_SUCCESS = 'RUN_FAKESHIELD_DTE_SUCCESS'; 
export const RUN_FAKESHIELD_DTE_FAILURE = 'RUN_FAKESHIELD_DTE_FAILURE';

export const RUN_FAKESHIELD_MFLM_REQUEST = 'RUN_FAKESHIELD_MFLM_REQUEST';
export const RUN_FAKESHIELD_MFLM_SUCCESS = 'RUN_FAKESHIELD_MFLM_SUCCESS'; 
export const RUN_FAKESHIELD_MFLM_FAILURE = 'RUN_FAKESHIELD_MFLM_FAILURE';